import axios from "axios";
import {apiRoot} from "../../index";
import {useContext, useEffect, useState} from "react";
import {UserContext} from "../../App";
import {startLoading, stopLoading} from "../loader";

export function verifyRight(userInfos, object, action) {
  // no user infos
  if (!userInfos) return false;

  // TODO : remove to enable agents page
  if (object === "agents" || object === "settings") {
    return [
      "contact@mydriverparis.com",
      "sylvainkatchikian@gmail.com",
    ].includes(userInfos.email);
  }

  // user is admin (not a child)
  if (!userInfos?.createdBy) return true;

  let rights = userInfos?.child?.rights;

  // verify rights are initialised
  if (!rights || !rights[object]) return false;

  // verify right
  return rights[object][action];
}

export function isExternal(userInfos) {
  return userInfos.createdBy && userInfos?.child?.isExternal;
}

export async function getChildUserInfos(token, uid) {
  startLoading();

  let res = null;
  try {
    res = await axios.post(
      `${apiRoot}/api/v1/users/get-child-infos`,
      {
        uid,
      },
      {
        headers: {
          Authorization: token,
        },
      }
    );
  } catch (e) {
    stopLoading();
    throw new Error(e?.response?.data ?? "Une erreur est survenue");
  }

  stopLoading();

  return res.data;
}

export async function getMyUserInfos(token, uid) {
  startLoading();

  let res = null;
  try {
    res = await axios.post(
      `${apiRoot}/api/v1/users/get-my-infos`,
      {},
      {
        headers: {
          Authorization: token,
        },
      }
    );
  } catch (e) {
    stopLoading();
    throw new Error(e?.response?.data ?? "Une erreur est survenue");
  }

  stopLoading();

  return res.data;
}

export async function createUser(token, data, userRights) {
  startLoading();

  let res = null;
  try {
    res = await axios.post(
      `${apiRoot}/api/v1/users/create`,
      {
        email: data.email,
        password: data.password,
        isExternal: data.isExternal,
        rights: userRights,
      },
      {
        headers: {
          Authorization: token,
        },
      }
    );
  } catch (e) {
    stopLoading();
    throw new Error(e?.response?.data ?? "Une erreur est survenue");
  }

  stopLoading();

  return res.data;
}

export async function updateUser(token, uid, isExternal, rights) {
  startLoading();

  let res = null;
  try {
    res = await axios.post(
      `${apiRoot}/api/v1/users/update-rights`,
      {
        uid,
        isExternal,
        rights,
      },
      {
        headers: {
          Authorization: token,
        },
      }
    );
  } catch (e) {
    stopLoading();
    throw new Error(e?.response?.data ?? "Une erreur est survenue");
  }

  stopLoading();

  return res.data;
}

export async function getUsers(token) {
  startLoading();

  const res = await axios.get(`${apiRoot}/api/v1/users`, {
    headers: {
      Authorization: token,
    },
  });

  stopLoading();

  return res.data;
}

export async function deleteUsers(token, uidListToDelete) {
  startLoading();

  const res = await axios.post(
    `${apiRoot}/api/v1/users/delete`,
    {
      uidListToDelete,
    },
    {
      headers: {
        Authorization: token,
      },
    }
  );

  stopLoading();

  return res.data;
}

export async function updateUserBranding(token, uid, branding) {
  startLoading();
  try {
    const res = await axios.post(
      `${apiRoot}/api/v1/users/${uid}/branding`,
      {branding},
      {
        headers: {Authorization: token},
      }
    );
    return res.data;
  } catch (e) {
    throw new Error(e?.response?.data ?? "Une erreur est survenue");
  } finally {
    stopLoading();
  }
}

export async function uploadUserBrandingLogo(token, uid, file) {
  startLoading();
  try {
    const formData = new FormData();
    formData.append("logo", file);

    const res = await axios.post(
      `${apiRoot}/api/v1/users/${uid}/branding/logo`,
      formData,
      {
        headers: {
          Authorization: token,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return res.data; // { logoPath, logoGsUri }
  } catch (e) {
    throw new Error(e?.response?.data ?? "Une erreur est survenue");
  } finally {
    stopLoading();
  }
}

export function useUsers() {
  const {userInfos} = useContext(UserContext);

  const [users, setUsers] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    async function fetchData() {
      const _users = await getUsers(userInfos.jwt);

      setUsers(_users);
      setLoaded(true);
    }

    fetchData().then();
  }, [userInfos.jwt]);

  return {users, loaded};
}
